import React, { FC } from 'react';
import { Theme } from '@mui/material';

import { AppLightIcon, AppDarkIcon } from 'src/shared/components/icons';
import { getAppBrandConfigs } from 'src/shared/utils';

interface Props {
  theme: Theme;
  className?: string;
}

export const AppIcon: FC<Props> = ({ theme, className }) => {
  const brand = getAppBrandConfigs(theme.palette.mode);
  if (brand.logoIconUrl) {
    return <img alt="brand-logo" src={brand.logoIconUrl || brand.logoUrl} width="60" />;
  }
  return theme.palette.mode === 'dark' ? <AppDarkIcon className={className} /> : <AppLightIcon className={className} />;
};
